import { useFeatureFlags } from 'context-providers/feature-flag-provider';
import Header from './components/header';
import FeaturedProduct from './components/featured-product';
import { createGlobalStyle } from 'styled-components';
import * as styles from './styles';

// BELOW: still needs refactor
import ProductGrid from './components/product-grid';
import { Product } from 'entities/product';

const GlobalStyle = createGlobalStyle`
  main {
    margin-top: -56px;
    background-color: var(--fill-brand);
  }
`;

interface ProductsPageProps {
  products: Product[];
}

const ProductsPage = ({ products }: ProductsPageProps) => {
  const featuredProduct = products.find((product) => product.isFeatured);
  const { featureFlags } = useFeatureFlags();
  const isVsOutOfStock = featureFlags?.isVsOutOfStock ?? false;

  return (
    <>
      <GlobalStyle />
      <Header />
      {featuredProduct && <FeaturedProduct featured={featuredProduct} />}

      {/* BELOW: still needs refactor */}
      <styles.ProductsSection id='products-grid'>
        <ProductGrid products={products} isVsOutOfStock={isVsOutOfStock} />
      </styles.ProductsSection>
    </>
  );
};

export default ProductsPage;
